export interface Language {
    langcode: string,
    locale?: any,
    language: string
 }

export enum LanguageCode {
    DE = "de",
    EN = "en"
}